export default function Button({
  children,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  fullWidth = true,
}) {
  const variants = {
    primary:
      "bg-[var(--color-primary)] text-[var(--color-text-on-primary)] light:text-white shadow-[0_0_10px_var(--color-shadow-primary)]" +
      " hover:shadow-[0_0_22px_var(--color-shadow-primary-hover)] hover:-translate-y-[1px] active:translate-y-[1px] active:shadow-[0_0_8px_var(--color-shadow-primary)]",
    secondary:
      "bg-[var(--color-bg-darker)] hover:bg-[var(--color-bg-darkest)] text-[var(--color-text-primary)] border border-[var(--color-border)] hover:border-[var(--color-primary)] hover:shadow-[0_0_10px_var(--color-primary-50)] hover:-translate-y-[1px] active:translate-y-[1px]",
    tertiary:
      "bg-[var(--color-bg-darker)] hover:bg-[var(--color-bg-darkest)] text-[var(--color-text-primary)] border border-[var(--color-border)] hover:border-[var(--color-primary)] hover:shadow-[0_0_10px_var(--color-primary-50)] hover:-translate-y-[1px] active:translate-y-[1px]",
  };

  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "";
  const widthClass = fullWidth ? "w-full" : "";

  let buttonClasses = "";
  if (className) {
    buttonClasses = `${className} ${disabledStyles}`;
  } else {
    buttonClasses = `${widthClass} py-3 px-4 rounded-lg font-medium transition-all duration-300 ${variants[variant]} ${disabledStyles}`;
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
    >
      {children}
    </button>
  );
}
